import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaChartBar, FaCogs, FaBullseye } from "react-icons/fa";
import axios from "axios";
import { baseurl } from "../Baseurl";

export default function UserTabMenu() {
  const [role, setRole] = useState("");
  const assignee_id = localStorage.getItem("assignee_id");
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("product");
  const [darkMode, setDarkMode] = useState(false);

  // ✅ Fetch role and store org_id & user_id
  useEffect(() => {
    const fetchRole = async () => {
      if (!assignee_id) {
        Swal.fire("Error", "Assignee ID not found in local storage", "error");
        return;
      }

      try {
        const res = await axios.get(`${baseurl}getAssigneeRoleById/${assignee_id}`);
        if (res.data.success) {
          const { role, org_id, user_id } = res.data;
          setRole(role);
          localStorage.setItem("user_org_id", org_id);
          localStorage.setItem("assignee_user_id", user_id);
        } else {
          Swal.fire("Error", res.data.message || "Failed to fetch role", "error");
        }
      } catch (err) {
        console.error("Error fetching assignee role:", err);
        Swal.fire("Error", "Server error while fetching role", "error");
      }
    };

    fetchRole();
  }, [assignee_id]);

  // ✅ Detect tab from URL hash or pathname
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (hash === "product" || hash === "operations" || hash === "strategy") {
      setActiveTab(hash);
    } else if (location.pathname.includes("operation")) {
      setActiveTab("operations");
    } else if (location.pathname.includes("strategic")) {
      setActiveTab("strategy");
    } else {
      setActiveTab("product");
    }
  }, [location]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    window.location.hash = tab;
  };

  return (
    <>
      {(role === "Manager" || role === "Owner") && (
        <div className="container-fluid mt-2">
          <div className="d-flex gap-3 bg-white-bg1 p-2 rounded justify-content-between">

            <Link
              to="/user-dashboard"
              className={`btn tab-btn w-100 ${activeTab === "product" ? "active-tab tab1" : ""}`}
              onClick={() => handleTabChange("product")}
            >
              <span
                className={`mainttl ${darkMode ? "dark" : ""} ${
                  activeTab === "product" ? "text-white" : ""
                }`}
              >
                <FaChartBar className="me-2" />
                Product Management
              </span>
            </Link>

            <Link
              to="/user-operation-board"
              className={`btn tab-btn w-100 ${activeTab === "operations" ? "active-tab tab2" : ""}`}
              onClick={() => handleTabChange("operations")}
            >
              <span
                className={`mainttl ${darkMode ? "dark" : ""} ${
                  activeTab === "operations" ? "text-white" : ""
                }`}
              >
                <FaCogs className="me-2" />
                Operational Management
              </span>
            </Link>

            <Link
              to="/user-strategic-board"
              className={`btn tab-btn w-100 ${activeTab === "strategy" ? "active-tab tab3" : ""}`}
              onClick={() => handleTabChange("strategy")}
            >
              <span
                className={`mainttl ${darkMode ? "dark" : ""} ${
                  activeTab === "strategy" ? "text-white" : ""
                }`}
              >
                <FaBullseye className="me-2" />
                Strategic Management
              </span>
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
